import { ApolloError } from '@apollo/client';
import React, { useEffect } from 'react';

import { GenericErrorPage } from '../GenericErrorPage';

export function Error(props: { error: ApolloError }): React.ReactElement {
  useEffect(() => {
    // We should probably fail tests if we hit this error
    console.error(props.error);
  }, [props.error]);
  return <GenericErrorPage message="Sorry but we could not load the content that you requested" />;
}
